'use strict';

import React, { Component } from 'react';
import ChatOverlayContent from 'components/ChatOverlayContent';
import { supportedOverlays } from 'components/ChatOverlayContent';

class ChatOverlay extends Component {
	constructor(props) {
		super(props);
	}

	renderContent( overlay ) {
		if ( ! this.supportedOverlays.includes( overlay ) ) {
			return;
		}

		const computedOverlay = overlay[0].toUpperCase() + overlay.slice(1),
			Content = `ChatOverlay${computedOverlay}`;

		return (
			<Content />
		)
	}

	renderCloseButton() {
		return (
			<button className="close-overlay close" onClick={this.props.onClose}/>
		);
	}

	render() {
		if ( ! this.props.isVisible ) {
			return null;
		}

		return (
			<div className={`chat-overlay modal-body ${this.props.content}`}>
				{this.renderCloseButton()}
				<ChatOverlayContent layout={this.props.content} {...this.props}/>
			</div>
		);
	}
}

ChatOverlay.displayName = 'ChatOverlay';
ChatOverlay.propTypes = {
	isVisible: React.PropTypes.bool,
	content: React.PropTypes.string,
	onClose: React.PropTypes.func,
	onFeedbackRequest: React.PropTypes.func
};
ChatOverlay.prototype.supportedOverlays = supportedOverlays;

export default ChatOverlay;

export {
	supportedOverlays
}


// WEBPACK FOOTER //
// ./src/components/ChatOverlay.js